module.exports = __webpack_public_path__ + "img/delete_content_primary.b46374e4.svg";